/** Skeleton CSS del panel de subsesiones mientras carga. */
export const SubsessionsPanelBones = () => (
    <div className="vc-bo__skeleton" aria-hidden="true">
        <div className="vc-bo__skel vc-bo__skel--btn" />
        <div className="vc-bo__skel vc-bo__skel--line" />
        <div className="vc-bo__skel vc-bo__skel--line is-short" />
        <div className="vc-bo__skel vc-bo__skel--title" />
        <div className="vc-bo__skel-row">
            <div className="vc-bo__skel vc-bo__skel--line" />
            <div className="vc-bo__skel vc-bo__skel--chip" />
        </div>
        <div className="vc-bo__skel-row">
            <div className="vc-bo__skel vc-bo__skel--line is-mid" />
            <div className="vc-bo__skel vc-bo__skel--chip" />
        </div>
        <div className="vc-bo__skel vc-bo__skel--title" />
        <div className="vc-bo__skel vc-bo__skel--card" />
        <div className="vc-bo__skel vc-bo__skel--card" />
    </div>
);
